import React, {Fragment} from 'react';
import monkey from '../../../images/monkey-not-found.png'
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import auth from "../../../utils/authentication";

function monkeyNotFound(){

    return(
        <div className="d-flex flex-row flex-wrap justify-content-center">
            <img src={monkey} style={{width: '60%'}} alt="Not found"/>
            <div className="col-12 d-flex justify-content-center mb-1 mt-3" style={{fontSize: "larger", fontWeight: "bolder"}}>
                <FormattedMessage id="app.error.not-found"/>
            </div>
            {auth.currentUser && <Fragment>
                <div className="col-12 d-flex justify-content-center mb-3" style={{fontSize: "small"}}>
                    <FormattedMessage id="app.error.not-found-message"/>
                </div>
                <Link to="/home" className="btn btn-outline-secondary"><FormattedMessage id="app.error.go-home"/></Link>
            </Fragment>}
            {!auth.currentUser && <Fragment>
                <div className="col-12 d-flex justify-content-center mb-3" style={{fontSize: "small"}}>
                    <FormattedMessage id="app.error.not-logged-in"/>
                </div>
                <button className="btn btn-outline-secondary"><FormattedMessage id="users.login.log-in"/></button>
            </Fragment>}
        </div>
    )

}

export default  monkeyNotFound;
